import * as  i18n from "../i18n.ts";
import Icons from "../svg/Icons.ts";
import { TEMPLATE } from "../TEMPLATE.ts";

export function template_gallery(context){
  return TEMPLATE`<flexcol class="main">
  <flexrow style="margin-bottom:16px">
    <flexauto>
      <line class="h1">${i18n.get('mainMenu.photos')}</line>
    </flexauto>
  </flexrow>
  <flexcol class="selectable" style="gap:var(--space);">

    <line>${i18n.get('photos.title')}</line>
    ${template_gallery_item(context.all)}
    ${template_gallery_item(context.favorites)}
    
    <line>${i18n.get('photos.members')}</line>
    ${context.members.map(member=>template_gallery_item(member))}

  </flexcol>
  
  
</flexcol>`;
}

function template_gallery_item(album){
  return TEMPLATE`<flexrow data-fw-meta-id="${album.metaId}" class="border-pane" data-fw-onclick="controllerselect" style="height:64px">
  <icon style="font-size:40px;position:relative;border-radius:8px;background-image:url('${album.pictureUrl}&w=128&h=128&s=c');background-size: cover;">
  </icon>  
  <flexauto>
    <line>${album.name}</line>
    <line class="sub4">${gallery_detail(album)}</line>
  </flexauto>
</flexrow>`
}

export function template_gallery_content(albumAndContent){
  return TEMPLATE`<flexcol class="V4 gallery-album" data-fw-meta-id="${albumAndContent.head.metaId}">
  
  <flexrow style="gap:var(--space);">
    <icon class="phone-only hidden-print" data-fw-onclick="goback|gallery.php">${Icons.ic_arrow_left}</icon>  
    <flexauto>
      <line class="h1">${albumAndContent.head.name}</line>
      <line class="sub4">${gallery_detail(albumAndContent.head)}</line>
    </flexauto>  
    <icon data-widget="widget/action-menu" data-key="gallerymenu" class="rounded-border">${Icons.ic_more_horizontal}</icon>
  </flexrow>
  
  ${()=>{
    if(albumAndContent.content.length){
      return TEMPLATE`
  <div class="gallery-item-container flexauto">
    ${albumAndContent.content.map(content=>TEMPLATE`<a href="${content.url}"
        class="hover-controller color-branded"
        style="flex-basis: ${content.getFlexBasis(200)}px;aspect-ratio:${content.getLimitedRatio()};background-color:${content.color};background-position:50%;background-size:cover"
        data-src="${content.url(512,512,'r')}"
        data-fw-meta-id="${content.metaId}"
        data-media-viewer-group="photos-gallery"
        data-fw-onclick="fileview"
        data-fw-canDelete="${content.rights.canDelete}"
        >
        <icon class="media-selector hover-controlled" data-widget="widget/media-selector">${Icons.ic_checkmark_circle}</icon>
        ${content.isVideo()?TEMPLATE`
        <div style="position:absolute;left:50%;top:50%;overflow:visible">
          <icon style="position:absolute;left:-40px;top:-40px;width:80px;color:#fff" class="opacity50">${Icons.ic_play}</icon>
        </div>
        `:''}
      </a>`
    )}
    <div style="flex-grow:999"></div>
  </div>`
    }else{
      return TEMPLATE`
  <div class="emptystateblock flexcenter flexcol" style="flex:1">
    <img src="${albumAndContent.emptyState.img}">
    <h1>${i18n.get(albumAndContent.emptyState.title)}</h1>
    <p class="blockmargin" style="color:#888;">${i18n.get(albumAndContent.emptyState.text)}</p>
  </div>
  `
    }
  }}
   ${()=>{
    if(albumAndContent.head.canAdd){
      return TEMPLATE`<div class="fab button" data-fw-onclick="galleryadd">
      <icon>${Icons.ic_add_plus}</icon>
    </div>`
    }
   }}
   
  
</flexcol>`
}


function gallery_detail(album){
  var result = []
  if(album.numberPictures>0){
    result.push(i18n.get('gallery.photo',album.numberPictures))
  }
  if(album.numberVideos>0){
    result.push(i18n.get('gallery.video',album.numberVideos))
  }
  return result.length>0?result.join(' - '):i18n.get('gallery.nothing')
  
}